import { React, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ContestBox from "./ContestBox/ContestBox";
import JoinViaInviteCode from "../JoinViaInviteCode/JoinViaInviteCode";
import BaseHome from "../Home/BaseHome";
import RulesPopup from "../Popup/RulesPopup";
import WinningBreakup from "../Popup/WinningPopup";
import JoinViaInviteCodePopup from "../Popup/JoinViaInviteCodePopup";
import TournamentRoundPopup from "../Popup/SelectRoundPopup";
import JoiningPopup from "../Popup/JoiningPopup";
import { useEffect } from "react";
import { getContestList, contestJoin, contestByCode } from "../../api/contest.api";
import { scrimByCode } from "../../api/scrim.api";
import TeamRegistration from "../Common/TeamRegistration";
import { toastError, toastSuccess } from '../../Utilities/toast.js'
import { useNavigate } from "react-router";
import ContestViaCode from "../Common/JoinViaContestCode.jsx";
import ScrimViaCode from "../Common/JoinViaScrimCode.jsx";
import ListLoader from "../Common/ListLoader.jsx";
import NonPremiumMaxJoinPopup from "../Common/NonPremiumMaxJoin.jsx";
import moment from "moment";

const ContestList = () => {
  const navigate = useNavigate();
  const [isRulesPopup, setIsRulesPopup] = useState(false);
  const [isPricePointPoolModel, setPricePointPool] = useState(false);
  const [isJoinViaInviteCode, setisJoinViaInviteCode] = useState(false);
  const [isTournamentRound, setisTournamentRound] = useState(false);
  const [isJoiningPopup, setJoiningPopup] = useState(false);
  const [selectedContest, setSelectedContest] = useState('');
  const [uniqueIgn, setUniqueIgn] = useState(null);
  const [isTeamRegistrationForm, setIsTeamRegistrationForm] = useState(false);
  const { t } = useTranslation(); const [isContest, setIsContest] = useState(false);
  const [isPrivateContest, setIsPrivateContest] = useState(false);
  const [joinViaCodeContest, setJoinViaCodeContest] = useState({});
  const [joinViaCodePrivateContest, setJoinViaCodePrivateContest] = useState({});
  const [contestList, setContestList] = useState([]);
  const [userId, setuserId] = useState(null);
  const [gameName, setGameName] = useState('');
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(4);
  const [totalPages, setTotalPages] = useState(1);
  const [isSubscriptionPopup, setSubscriptionPop] = useState(false);
  const [isDisableJoinBtn, setIsDisableJoinBtn] = useState(false);
  const [selectedMatchDate, setSelectedMatchDate] = useState('');

  const [paginationFilter, setPaginationFilter] = useState({
    pageNo: currentPage,
    recordPerPage: recordPerPage,
    sortBy: 'dateTime',
    sortDirection: 'asc'
  });


  const [code, setCode] = useState('');
  const [rules, setRules] = useState([
    "KRAFTON will endeavor to eradicate misconducts described in the Rules of Conduct to ensure that the users can enjoy playing the game.",
  ]);

  useEffect(() => {
    setuserId(JSON?.parse(localStorage.getItem("profile"))?.user_id)
    let selectedGameName = localStorage.getItem('activeGameTypeName')
    setGameName(selectedGameName)
 
  }, [])


  
  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  //infinite scroll
  const loadMore = async () => {
    setLoading(true)
    fetchContestList()
   
  }
  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchContestList = async () => {
    try {
      let selectedGame = localStorage.getItem('activeGameId')
      let selectedGameType = localStorage.getItem('activeGameTypeId')
      let tempPagination = paginationFilter;
      paginationFilter.pageNo= currentPage
      paginationFilter.recordPerPage=recordPerPage
      let payload = {
        search: {
          gameType: selectedGameType,
          game: selectedGame,
          user: JSON?.parse(localStorage.getItem("profile"))?.user_id
        },
        pagination: tempPagination,
      }
      const res = await getContestList(payload);
      if (res?.success && res?.data) {
        setTotalPages(res?.totalPages)
        setContestList([...contestList, ...res?.data])
        setLoading(false)
      }
      else {
        
        setContestList([])
        setLoading(false)
      }
    } catch (error) {
    }
  };
  const onJoinContestClick = (contest) => {
    setSelectedContest(contest);
    setIsDisableJoinBtn(false);
    setJoiningPopup(true);
  }
  const onJoinedContestDetails = (contest) => {
    console.log(contest)
    navigate(`/contest/details/${contest._id}`)
  }
  const joiningContest = (contest) => {
    if (
      selectedContest?.gameTypeAry?.players &&
      parseInt(selectedContest?.gameTypeAry?.players) > 1
    ) {
      let data = {
        contest: selectedContest?._id,
        isActive: true,
        type: "contest",
        currencyCode: selectedContest?.currency?.[0]?.inCurrency?._id, //TODO: need to use get currency is function here avoid direct use incurrency 
        inGameUserName: uniqueIgn,
        uniqueIGN: uniqueIgn,
        user: userId
      };

      data.players = selectedContest?.gameTypeAry?.players
      data.extraPlayers = selectedContest?.gameTypeAry?.extraPlayers
      data.game_type = selectedContest?.gameTypeAry?._id
      data.game = selectedContest?.gameAry?._id
      localStorage.setItem("registerData", JSON.stringify(data))
      localStorage.setItem("registerType", "contest")

      setJoiningPopup(false);
      navigate("/team-registration")
    } else {
      soloContestJoin();
    }
  }
  const soloContestJoin = async () => {
    try {
      let data = {
        contest: selectedContest?._id,
        inGameUserName: uniqueIgn,
        user: JSON?.parse(localStorage.getItem("profile"))?.user_id
      };
      const res = await contestJoin(data);
      if (res?.success && res?.data) {
        setJoiningPopup(false);
        toastSuccess('Contest Join Successfully!');
        navigate(`/contest/details/${selectedContest?._id}`)
      }
      else {
        if(res?.data?.errors[0]?.code==="joinUserContests.messages.max_limit_exceed"){
          setJoiningPopup(false);
          setSubscriptionPop(true)
        }
        else if(res?.data?.errors[0]?.code==="events.validation.insufficient_balance") {
          toastError(res?.data?.errors?.[0]?.msg);
          setInterval(() => {
            navigate(`/rewards`, { state: { status: 'coinStore' } })
          }, 2000);
        }
        else{
          setIsDisableJoinBtn(false);
          toastError(res?.data?.errors?.[0]?.msg);
        }
      }
    } catch (error) {
      setIsDisableJoinBtn(false);
      console.log(error)
    }
  };




  async function handleApplyClick() {
    if (code?.trim()) {
      handleContestByCode(code);
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeContest({});
    }
  }
  async function handleContestByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await contestByCode(payload);
        if (response?.success && response?.data) {
          setJoinViaCodeContest(response?.data);
          setIsContest(true)
          setIsPrivateContest(false)
          setCode('');
        } else {
          handleScrimByCode(code)
        }
      } catch (error) {
        handleScrimByCode(code)
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }
  
  async function handleScrimByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await scrimByCode(payload);
        if (response?.success && response?.data) {
          setJoinViaCodePrivateContest(response?.data);
          setIsContest(false)
          setIsPrivateContest(true)
          setCode('');
        } else {
          toastError(t('join_via_invite_code.contest_not_found'));
          setJoinViaCodeContest({});
          setJoinViaCodePrivateContest({});
          setIsContest(false)
          setIsPrivateContest(false)
          setCode('');
        }
      } catch (error) {
        toastError(t('join_via_invite_code.contest_not_found'));
        setJoinViaCodeContest({});
        setJoinViaCodePrivateContest({});
        setIsContest(false)
        setIsPrivateContest(false)
        setCode('');
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  return (
    <>
      <BaseHome title={gameName?.toLocaleLowerCase() || ''} onBackClick={() => navigate(-1)}>
        <JoinViaInviteCode setCode={setCode} code={code} handleApplyClick={handleApplyClick} />
       
        {
          contestList && contestList?.length>0 ? contestList?.map((contest, index) => {
            {/* { console.log("contest-Id", contest._id, index, loading) } */}
            return <>
              <div 
                key={contest._id}
                ref={contestList?.length === index + 1 ? lastPostElementRef : null}
              >
                <ContestBox contestData={contest} onJoinContestClick={onJoinContestClick} index={index}
                  onJoinedContestDetails={onJoinedContestDetails} />
              </div>
            </>
          }) :
            !loading && <div className='w-100 d-flex justify-content-center no-record-found-center'><span className="text-center">{t('common.no_data_found')}</span></div>
        }
        {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}

        {isRulesPopup && (
          <RulesPopup
            isOpen={isRulesPopup}
            title="Rules"
            onClose={() => setIsRulesPopup(false)}
            rules={rules}
          />
        )}
        {isPricePointPoolModel && (
          <WinningBreakup
            isOpen={isPricePointPoolModel}
            title="Winning Breakup"
            onClose={() => setPricePointPool(false)}
            popupType={'contest'}
          />
        )}
        {isJoinViaInviteCode && (
          <JoinViaInviteCodePopup
            isOpen={isJoinViaInviteCode}
            title="pubg"
            onClose={() => setisJoinViaInviteCode(false)
            }
          />
        )}
        {isTournamentRound && (
          <TournamentRoundPopup
          setSelectedMatchDate={setSelectedMatchDate}
            isOpen={isTournamentRound}
            title="pmco"
            onClose={() => setisTournamentRound(false)}
          />
        )}
        {isJoiningPopup && (
          <JoiningPopup  // contest Join popup
            isOpen={isJoiningPopup}
            title={selectedContest?.title}
            popupType={'contest'}
            contest={selectedContest}
            setingameName={setUniqueIgn}
            selectedMatchDate={moment(selectedContest?.date).format("Do MMM YYYY") + ", " + moment(selectedContest?.date).format("hh:mm A") }
            onJoinContest={joiningContest}
            onClose={() => setJoiningPopup(false)}
            isDisableJoinBtn={isDisableJoinBtn}
            setIsDisableJoinBtn={setIsDisableJoinBtn}
          />
        )}
        {isContest && <ContestViaCode joinViaCodeContest={joinViaCodeContest} onJoinedContestDetails={onJoinedContestDetails} />}
        {isPrivateContest && <ScrimViaCode joinViaCodePrivateContest={joinViaCodePrivateContest} />}
        {isSubscriptionPopup && (
          <NonPremiumMaxJoinPopup
          isOpen={isSubscriptionPopup}
          message={t('premium.you_have_already_joined_today', { title:  "contest"  , total: localStorage?.getItem('noOfContest')   })}
          onClose={() => setSubscriptionPop(false)} title={"explore vi premium"}
          onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }}/>
        )}
      </BaseHome>
    </>
  );
};

export default ContestList;
